import { FormikProps } from "formik";
import {
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../../opretFirmaInterface";
import { StickyFooter } from "../../../../stickyFooter/modalStickyFooter";
import Button from "@/components/bricks/button/Button";
import { SetStateAction } from "react";
import OpretFirmaKontaktoplysninger from "./OpretFirmaKontaktoplysninger";
import OpretFirmaFakturering from "./OpretFirmaFakturering";
import OpretFirmaSelskabstype from "./OpretFirmaSelskabstype";

const OpretFirmaStep2 = ({
  formik,
  setStep,
  step1,
}: {
  formik: FormikProps<OpretFirmaStep2Formik>;
  setStep: React.Dispatch<SetStateAction<number>>;
  step1: FormikProps<OpretFirmaStep1Formik>;
}) => {
  const { values: step1Values } = step1;
  return (
    <form autoComplete="off" onSubmit={formik.handleSubmit}>
      <div className="c-item-list c-modal-container-inner">
        {step1Values.inCVR === "no" && // 60, 70, 80 "Aktieselskab", "KommanditaktieselskabPartnerselskab", "Anpartsselskab"
          (step1Values.virksomhedsform === "Aktieselskab" ||
            step1Values.virksomhedsform ===
              "KommanditaktieselskabPartnerselskab" ||
            step1Values.virksomhedsform === "Anpartsselskab") && (
            <OpretFirmaSelskabstype formik={formik} />
          )}
        <OpretFirmaKontaktoplysninger formik={formik} />
        <OpretFirmaFakturering formik={formik} step1Values={step1.values} />
      </div>
      <StickyFooter>
        <>
          <Button color="secondary" onClick={() => setStep(1)}>
            Forrige
          </Button>
          <Button type="submit" color="primary">
            Opret
          </Button>
        </>
      </StickyFooter>
    </form>
  );
};

export default OpretFirmaStep2;
